import React from 'react';
import { motion } from 'framer-motion';
import { FingerprintIcon, ScanLineIcon, SearchIcon, SmartphoneIcon, ArrowRightIcon, DownloadIcon, UsersIcon, CalendarCheckIcon } from 'lucide-react';
export function Services() {
  const services = [{
    icon: SmartphoneIcon,
    title: 'Mobile Fingerprinting',
    description: 'We come to you. Our certified technicians travel to your office, facility, or business location with portable live scan equipment — no need for your team to leave the workplace.',
    highlight: true
  }, {
    icon: UsersIcon,
    title: 'Group Fingerprinting',
    description: 'For companies with 5 or more employees, we bring our full mobile setup directly to your facility. Fast, efficient processing for your entire team in one visit.',
    highlight: true
  }, {
    icon: ScanLineIcon,
    title: 'LiveScan Fingerprinting',
    description: 'State-of-the-art electronic fingerprint capture via glass plate scanner, transmitted directly to CJIS for processing. Available by appointment at our Columbia, MD office.'
  }, {
    icon: FingerprintIcon,
    title: 'Ink/Card Fingerprinting',
    description: 'Traditional ink-and-rolled fingerprint capture on official cards, submitted for processing and analysis. By appointment only.'
  }, {
    icon: SearchIcon,
    title: 'Background Checks',
    description: 'Comprehensive criminal history background checks through CJIS and the FBI. Required for employment, licensing, and certification purposes.'
  }, {
    icon: CalendarCheckIcon,
    title: 'Appointment Scheduling',
    description: 'All services are by appointment only — no walk-ins accepted. Book online in minutes and choose the date and time that works best for you or your organization.'
  }];
  return <section id="services" className="py-24 bg-white" aria-labelledby="services-heading" data-id="element-199">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <h2 id="services-heading" className="text-3xl md:text-4xl font-bold text-[#1E1F55] mb-4" data-id="element-202">
            Services We Offer
          </h2>
          <div className="w-24 h-1 bg-[#4AA6CF] mx-auto rounded-full mb-6" aria-hidden="true" data-id="element-203"></div>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-204">
            From on-site mobile fingerprinting to comprehensive background
            checks — all by appointment only.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-205">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white border rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all flex flex-col h-full group ${service.highlight ? 'border-[#4AA6CF]/30 ring-1 ring-[#4AA6CF]/10' : 'border-gray-100'}`} data-id="element-206">
              <div className="flex items-start gap-4 mb-4" data-id="element-207">
                <div className={`p-3 rounded-lg transition-colors ${service.highlight ? 'bg-[#4AA6CF]/10 text-[#4AA6CF] group-hover:bg-[#4AA6CF] group-hover:text-white' : 'bg-[#F0F4FF] text-[#4AA6CF] group-hover:bg-[#4AA6CF] group-hover:text-white'}`} data-id="element-208">
                  <service.icon className="h-8 w-8" aria-hidden="true" data-id="element-209" />
                </div>
                <div data-id="element-210">
                  <h3 className="text-xl font-bold text-[#1E1F55] mt-1" data-id="element-211">
                    {service.title}
                  </h3>
                  {service.highlight && <span className="inline-block mt-1 text-xs font-semibold text-[#4AA6CF] bg-[#4AA6CF]/10 px-2 py-0.5 rounded-full" data-id="element-212">
                      Featured
                    </span>}
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed mb-8 flex-grow" data-id="element-213">
                {service.description}
              </p>
              <a href="#/booking" className="inline-flex items-center text-[#2B7A9E] font-semibold hover:text-[#1E1F55] transition-colors mt-auto" data-id="element-214">
                Book Appointment
                <ArrowRightIcon className="ml-2 h-4 w-4" aria-hidden="true" data-id="element-215" />
              </a>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-216">
          <motion.a href="#" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-[#1E1F55] text-[#1E1F55] rounded-full font-bold hover:bg-[#1E1F55] hover:text-white transition-colors w-full sm:w-auto" aria-label="Download LiveScan Pre-Registration Form (PDF)" data-id="element-217">
            <DownloadIcon className="h-5 w-5" aria-hidden="true" data-id="element-218" />
            Download LiveScan Pre-Registration Form
          </motion.a>
        </div>
      </div>
    </section>;
}